import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20product%20flatlay%20with%20white%20sneakers%2C%20soft%20beige%20linen%20fabric%20draped%20naturally%2C%20delicate%20gold%20jewelry%20pieces%20scattered%20organically%2C%20a%20ceramic%20coffee%20cup%20with%20gentle%20steam%2C%20warm%20morning%20sunlight%20casting%20soft%20shadows%20across%20a%20light%20oak%20wooden%20surface%2C%20cream%20textured%20backdrop%2C%20editorial%20product%20photography%20with%20shallow%20depth%20of%20field%2C%20refined%20European%20aesthetic%2C%20calming%20neutral%20color%20palette&width=1920&height=1080&seq=hero-main-v2&orientation=landscape"
          alt="Elegant minimalist fashion and lifestyle product photography"
          title="Basetao Spreadsheet - Premium Shopping Resources"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full section-container">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white text-xs font-medium tracking-wide uppercase mb-6 border border-white/20">
            Independent Resource &amp; Guide Platform
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white leading-tight text-balance drop-shadow-lg">
            Basetao Spreadsheet &mdash; The Ultimate Product Database &amp; Shopping Guide
          </h1>

          <p className="mt-6 text-base md:text-lg text-white/85 leading-relaxed max-w-2xl mx-auto text-balance">
            Find the latest Basetao Spreadsheet resources, product recommendations, shipping information,
            warehouse guides, reviews and exclusive shopping tips in one powerful platform.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="bg-white text-foreground-950 hover:bg-white/90 font-medium rounded-md px-10 py-4 text-base transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Basetao Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="bg-accent-500 text-white hover:bg-accent-600 font-medium rounded-md px-10 py-4 text-base transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
            <Link
              to="/basetao-spreadsheet-guide"
              className="border-2 border-white/40 text-white hover:bg-white/10 hover:border-white font-medium rounded-md px-10 py-4 text-base transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Read Complete Guide
            </Link>
          </div>

          <div className="mt-12 flex flex-wrap items-center justify-center gap-6 text-white/75 text-xs md:text-sm">
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400"></i> Updated Spreadsheet Database
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400"></i> Verified Shopping Guides
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400"></i> Shipping Cost Analysis
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400"></i> Beginner Friendly Tutorials
            </span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#categories" className="text-white/60 hover:text-white transition-colors">
          <i className="ri-arrow-down-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}